
import "/app/src/modules/zy-crm/components/marketing-campaign-stats-section/style.module.less?modules";
export default {"costRow": `costRow-TLw8HGhz`,"stack": `stack-edOqQ3V9`,"block": `block-WQ6eQ12S`,"caption": `caption-HO8H0lmj`}
